// extracted by mini-css-extract-plugin
module.exports = {"snackContainer":"Snack_snackContainer__1kjMS","snackHeader":"Snack_snackHeader__lRyle","snackBody":"Snack_snackBody__16BWF","closeButton":"Snack_closeButton__2QdiR"};